export default __webpack_public_path__ + "static/media/genteDePerto.2acc8a25.jpg";